import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { datadogLogs } from '@datadog/browser-logs';
import { Button, Container, Typography } from '@mui/material';

import { DATADOG_404_ERROR_MESSAGE, INSURANCE_TYPE_PETOLO, imgLinks } from '../../shared';

import { StyledButtonContainer, StyledImg, StyledBackButton } from './PageNotFound.styled';

const Petolo404Page = () => {
  useEffect(() => {
    datadogLogs.logger.error(DATADOG_404_ERROR_MESSAGE, { product: INSURANCE_TYPE_PETOLO });
  }, []);

  return (
    <Container>
      <StyledBackButton to="/dashboard" label={<FormattedMessage id="common.button.back.home" />} />

      <StyledImg src={imgLinks['petolo.404.page']} alt="404" />

      <Typography variant="h2" align="center">
        <FormattedMessage id="petolo.404.page.message" />
      </Typography>

      <StyledButtonContainer>
        <Button href="/dashboard">
          <Typography variant="buttons">
            <FormattedMessage id="common.button.back.home" />
          </Typography>
        </Button>
      </StyledButtonContainer>
    </Container>
  );
};

export default Petolo404Page;
